import { render, staticRenderFns } from "./pressingViewDialog.vue?vue&type=template&id=f8d5061a"
import script from "./pressingViewDialog.vue?vue&type=script&lang=js"
export * from "./pressingViewDialog.vue?vue&type=script&lang=js"
import style0 from "./pressingViewDialog.vue?vue&type=style&index=0&id=f8d5061a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports